import { View } from 'react-native'
import { useAllowedDealTypes } from '@order/hooks/useDeals'

import ProgressivesLarge from './sections/ProgressivesLarge'
import SingleVision from './sections/SingleVision'
import Office from './sections/Office'
import AllDeals from './sections/AllDeals'
import TBGO from './sections/TBGO'
import { useConfigCondition } from 'features/config/useConfigCondition'

export default function IntroTilesVF() {
  const types = useAllowedDealTypes()
  const showAllDeals = useConfigCondition('intro:allDeals')

  return (
    <>
      <View className="gap-8 p-8 pt-0">
        <ProgressivesLarge />
        <View className="w-full flex-row gap-8">
          <SingleVision />
          <Office />
        </View>
        {showAllDeals && <AllDeals />}
        {types.includes('tgbo') && <TBGO />}
      </View>
    </>
  )
}
